import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modificacion-fisica',
  templateUrl: './modificacion-fisica.component.html',
  styleUrls: []
})
export class ModificacionFisicaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
